export enum ComponentId {
  PERSON_TYPE = "type",
  NAME = "name",
  SURNAME = "surname",
  COMPANY_NAME = "companyName",
  PHONE = "phone",
  EMAIL = "email",
}
